import { useQuery } from "@apollo/client/react";
import { GET_HONORARIO_PROFESIONAL } from "../../../../../data/graphQL/queries/GestionAsistencial/getHonorarioProfesional";

export function useTabProfesionalAddProfessionalRows({
  idClase,
  idDelegacion,
  idFiguraProfesional,
  idPlanCuidado,
  idTipoProfesional
}) {
  const skip =
  !idClase ||
  !idDelegacion ||
  idFiguraProfesional === null ||
  !idPlanCuidado ||
  !idTipoProfesional;

  const { data, loading } = useQuery(GET_HONORARIO_PROFESIONAL, {
    skip,
    variables: {
      filter: {
        idClase,
        idDelegacion,
        idFiguraProfesional,
        idPlanCuidado,
        idTipoProfesional
      }
    },
    fetchPolicy: 'no-cache'
  });

  const rows = data?.honorarioProfesional || [];
  const totalCount = rows.length || 0;

  return {
    rows,
    totalCount,
    loading
  };
}